import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_FRM_910 } from "@/lib/programs/marrakechFez910";

export default function MarrakechFez910Page() {
  return <ProgramTemplate program={PROGRAM_FRM_910} variant="frm" showJourneyChronology />;
}
